export function Header(): JSX.Element {
  return <div id="header">KAL</div>;
}
